import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import { injectIntl } from 'react-intl'
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Icon,
} from '@material-ui/core'
import * as SLHelper from 'helpers/seaLice'
import 'styles/app/apps/seaLice/site-info.scss'
import messages from '../translate'

class SLBarriosInfoTable extends Component {
  constructor(props) {
    super(props)
    this.state = {
      orderWeek: this.props.activeDate.isoWeek(),
      orderDirection: false,
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.sitesData !== nextProps.sitesData) {
      this.setState({
        orderWeek: this.props.activeDate.week(),
        orderDirection: false,
      })

      return false
    }

    return true
  }

  // eslint-disable-next-line max-statements
  getSiteData = () => {
    const data = []
    const keys = {}
    let columns = []
    const type = this.props.activeType
    const sitesData = this.props.sitesData.toArray()
    const barriosList = this.props.barriosList.toArray()
    const { orderWeek, orderDirection } = this.state

    for (const key in barriosList) {
      if (barriosList.hasOwnProperty(key)) {
        const barrio = barriosList[key]
        keys[barrio.id] = key
        data.push({
          id: barrio.id,
          name: barrio.name,
          weeks: {},
          sitesCount: 0,
        })
      }
    }

    for (const key in sitesData) {
      if (sitesData.hasOwnProperty(key)) {
        const site = sitesData[key]

        if (!site.neighborhood_id || !keys.hasOwnProperty(site.neighborhood_id))
          continue

        if (columns.length < 1) {
          columns = Array.from(site.weeks, x => x.week)
        }

        const barrio = data[keys[site.neighborhood_id]]
        const barrioWeekLength = Object.keys(barrio.weeks).length
        barrio.sitesCount += 1

        for (const key2 in site.weeks) {
          if (site.weeks.hasOwnProperty(key2)) {
            const week = site.weeks[key2]

            if (!barrio.weeks.hasOwnProperty(week.week)) {
              barrio.weeks[week.week] = null
            }

            if (!barrioWeekLength) {
              barrio.weeks[week.week] = week[type]
            } else if (barrioWeekLength && week[type]) {
              barrio.weeks[week.week] = +barrio.weeks[week.week] + +week[type]
            }
          }
        }
      }
    }

    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const barrio = data[key]
        const weeksKeys = Object.keys(barrio.weeks)

        if (!weeksKeys.length) {
          delete data[key]
          continue
        }

        for (const wk in weeksKeys) {
          if (
            weeksKeys.hasOwnProperty(wk) &&
            barrio.weeks[weeksKeys[wk]] !== null
          )
            barrio.weeks[weeksKeys[wk]] =
              Math.round(
                (barrio.weeks[weeksKeys[wk]] / barrio.sitesCount) * 100,
              ) / 100
        }
      }
    }

    data.sort((a, b) =>
      orderDirection
        ? a.weeks[orderWeek] - b.weeks[orderWeek]
        : b.weeks[orderWeek] - a.weeks[orderWeek],
    )

    return { columns, data }
  }

  onWeekOrder = e => {
    const _week = +e.currentTarget.dataset.week
    const { orderWeek, orderDirection } = this.state

    if (_week === orderWeek) {
      this.setState({ orderDirection: !orderDirection })
    } else {
      this.setState({ orderWeek: _week, orderDirection: false })
    }
  }

  render() {
    const {
      intl: { formatMessage },
      barriosList,
      activeType,
      activeDate,
    } = this.props

    if (barriosList.size < 1) return null

    const { columns, data } = this.getSiteData()
    const activeWeek = activeDate.isoWeek()
    const { orderWeek, orderDirection } = this.state

    return (
      <div className="sealice-table">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{formatMessage(messages.barrio)}</TableCell>
              {columns.map((w, k) => (
                <TableCell
                  key={k}
                  className={cn({ activeCell: activeWeek === w })}>
                  <span
                    className={cn('weekTitle', { active: orderWeek === w })}
                    data-week={w}
                    onClick={this.onWeekOrder}>
                    W{w}{' '}
                    {orderWeek === w && (
                      <Icon>
                        {orderDirection ? 'arrow_drop_up' : 'arrow_drop_down'}
                      </Icon>
                    )}
                  </span>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, i) => (
              <TableRow key={i}>
                <TableCell component="th" scope="row" data-label="Site Name">
                  {row.name}
                </TableCell>
                {columns.map((w, k) => (
                  <TableCell
                    key={k}
                    className={cn({ activeCell: activeWeek === w })}
                    data-label={`Week ${w}`}>
                    <span
                      className={`week-value ${SLHelper.getBackgroundColor(
                        row.weeks[w],
                        activeType,
                      )}`}>
                      {row.weeks[w] !== null ? row.weeks[w] : 'N/A'}
                    </span>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    )
  }
}

export default connect(state => ({
  sitesData: state.getIn(['seaLice', 'sitesData']),
  barriosList: state.getIn(['seaLice', 'barriosList']),
  activeDate: state.getIn(['seaLice', 'activeDate']),
  activeType: state.getIn(['seaLice', 'activeType']),
}))(injectIntl(SLBarriosInfoTable))
